import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Box, Typography, Grid, Radio, RadioGroup, FormControlLabel, FormControl, FormHelperText, Button, useMediaQuery, Stack, Dialog, DialogTitle, DialogContent, DialogActions, debounce, IconButton } from "@mui/material";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import CustomTextField from "../commoncomponents/CustomTextField";
import CustomTextArea from "../commoncomponents/CustomTextArea";
import AddIcon from '@mui/icons-material/Add';
import ComponentHeader from "../commoncomponents/ComponentHeader";
import CustomTextFieldWithSearch from "../commoncomponents/CustomTextFieldWithSearch";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import CustomDateTimePicker from "../commoncomponents/CustomDateTimePicker";
import { useDispatch, useSelector } from "react-redux";
import workOrderSummaryRepositry from "../../api/repositories/workOrderSummaryRepositries";
import { addRepairTrackerDetails, assessmentsDetails, clearRepairtracker, updateAssessmentsPartsInitialState, updateAssessmentsPartsRequired, updateOutsourceDetails, updateRepairTrackerDetails, updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import dayjs from "dayjs";
import BottomButtonsforWorkOrder from "./BottomButtonsforWorkOrder";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { useLocation, useNavigate } from "react-router-dom";
import { format, set } from "date-fns";
import { v4 as uuidv4 } from 'uuid';
import CustomDialog from "../commoncomponents/CustomDialog";
import CustomTimePicker from "../commoncomponents/CustomTimePicker";
import PageLoader from "../commoncomponents/PageLoader";
import { mandatoryFields } from "../../redux/actions/assetActions";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import { getAuthToken, getcompanyId } from "../../utility/tokenUtility";
import { processingPercentageValue, statusList } from "../../utility/message";
import { FieldAlreadyExistsError } from "pdf-lib";


const AddRowDialogue = ({ open, onClose, editMode, rows, setRows, vendorId, RepairType, RespondedEndDateandTime }) => {

  const dispatch = useDispatch();

  const assetCategoryType = useSelector((state) => state?.serviceType);
  const categoryType = assetCategoryType?.category;
  const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";

  const initialState = {
    employeename: '',
    flag: {},
    pic: {},
    activity: {},
    remarks: "",
    technician: "",
    vendorId: vendorId || "",
    startDateandTime: "",
    endDateandTime: "",
    repairDuration: ""
  };

  const [itemData, setItemData] = useState(initialState || {});
  const [isFirstRowDisable, setIsFirstRowDisable] = useState(false);
  const basicDetails = useSelector((state) => state.workOrderBasicDetails);
  const setOutsourceDetails = basicDetails?.vendorField;

  const [option, setOption] = useState({
    employeename: [],
    flag: [],
    pic: [],
    activity: [],
  });

  const [error, setError] = useState({
    startDateandTime: false,
    endDateandTime: false,
    employeename: false,
    technician: false
  });

  const [errorMessage, setErrorMessage] = useState({
    startDateandTime: "",
    endDateandTime: "",
    employeename: "",
    technician: ""
  });



  const handleChangeForRepairTracker = (value, name) => {
    const values = name === "repairDuration" || name === "preparationHours" || name === "verificationHours"
      ? value?.slice(0, 2) + value?.slice(2) : value;

    setItemData((previous) => {
      const updatedData = {
        ...previous,
        [name]: values || ""
      };

      if (name === "employeename") {
        updatedData.employeename = { ...value, label: value?.employeename ? value?.employeename : '' };
      };

      if (name === "startDateandTime" || name === "endDateandTime") {
        const start = new Date(updatedData.startDateandTime);
        const end = new Date(updatedData.endDateandTime);
        if (start && end && end >= start) {
          const durationInMs = end - start;
          const totalMinutes = Math.floor(durationInMs / (1000 * 60)); // Convert duration to total minutes
          updatedData.repairDuration = `${totalMinutes} Mins`;
        } else {
          updatedData.repairDuration = "0 Mins";
        }
      }


      return updatedData;
    });

    setError((prev) => {
      const updatedError = {
        ...prev,
        [name]: false
      };
      return updatedError;
    });

    setErrorMessage((prev) => ({
      ...prev,
      [name]: ''
    }));

    const workOrderDateAndTime = new Date(categoryType === "Scheduled" ? basicDetails?.workorderDateandTime : RespondedEndDateandTime);
    const selectedDate = new Date(value);
    const currentDate = new Date();
    const endDate = new Date(itemData?.endDateandTime);

    if (name === 'startDateandTime' && value) {

      // if (selectedDate < workOrderDateAndTime || selectedDate > currentDate) {
      if (categoryType === "Scheduled" ? (selectedDate < workOrderDateAndTime || selectedDate > currentDate) : selectedDate < workOrderDateAndTime) {
        setError((prevErrors) => ({
          ...prevErrors,
          startDateandTime: true,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          startDateandTime: categoryType === "Scheduled" ? "Start date and time should be between Work Order date and current date/time." :
            "Start date and time should be greater than Responded end date and time.",
        }));
      } else {
        setError((prevErrors) => ({
          ...prevErrors,
          startDateandTime: false,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          startDateandTime: "",
        }));
      }

      if (endDate && selectedDate) {
        if (selectedDate >= endDate) {
          setError((prevErrors) => ({
            ...prevErrors,
            endDateandTime: true,
          }));
          setErrorMessage((prevErrorMessages) => ({
            ...prevErrorMessages,
            endDateandTime: "End date and time should be greater than the Start date and time.",
          }));
        } else {
          setError((prevErrors) => ({
            ...prevErrors,
            endDateandTime: false,
          }));
          setErrorMessage((prevErrorMessages) => ({
            ...prevErrorMessages,
            endDateandTime: "",
          }));
        }
      };
    };

    if (name === 'endDateandTime' && value) {
      const selectedEndDateTime = new Date(value);
      const startDateTime = new Date(itemData?.startDateandTime);
      if (selectedEndDateTime < startDateTime) {
        setError((prevErrors) => ({
          ...prevErrors,
          endDateandTime: true,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          endDateandTime: "End date and time should be greater than the Start date and time.",
        }));
      } else {
        setError((prevErrors) => ({
          ...prevErrors,
          endDateandTime: false,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          endDateandTime: "",
        }));
      };
    };
  };

  const fetchOption = async () => {
    const employeeName = await workOrderSummaryRepositry.fetchEmployeeDetails();
    setOption((previous) => ({
      ...previous,
      employeename: employeeName?.map((item, index) => ({
        key: `option${index}`,
        label: `${item?.employeecode || ""} - ${item?.employeename || ""}` || "",
        employeename: item?.employeename || "",
        employeecode: item?.employeecode || "",
        designation: item?.designation || "",
        empservice: item?.empservice || "",
        id: item?.id || ""
      }))
    }));

    const lovOptions = await workOrderSummaryRepositry.lovOptions();
    setOption((previous) => ({
      ...previous,
      flag: lovOptions?.femuschworepairflags?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairflag,
        id: item?.id
      }))
    }));

    setOption((previous) => ({
      ...previous,
      pic: lovOptions?.femuschworepairpics?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairpic,
        id: item?.id
      }))
    }));

    setOption((previous) => ({
      ...previous,
      activity: lovOptions?.femuschworepairactivities?.map((item, index) => ({
        key: `option${index}`,
        label: item?.repairactivity,
        id: item?.id
      }))
    }));
  };

  useEffect(() => {
    const fetchData = async () => {
      // setLoading(true);
      await fetchOption();
      // setLoading(false);
    };
    fetchData();


  }, []);

  useEffect(() => {
    setItemData((prev) => ({
      employeename: '',
      flag: {},
      pic: {},
      activity: {},
      remarks: "",
      technician: "",
      vendorId: vendorId || "",
      // startDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? RespondedEndDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss") : RespondedEndDateandTime || "",
      startDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "" : "",
      endDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "" : "",
      repairDuration: categoryFieldName === "scheduled" ? "0 Mins" : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "0 Mins" : "",
    }))
  }, [RespondedEndDateandTime]);


  const handleCancel = () => {
    setItemData((prev) => ({
      employeename: '',
      flag: {},
      pic: {},
      activity: {},
      remarks: "",
      technician: "",
      vendorId: vendorId || "",
      // startDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? RespondedEndDateandTime || dayjs().format("YYYY-MM-DDTHH:mm:ss") : RespondedEndDateandTime || "",
      startDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "" : "",
      endDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "" : "",
      repairDuration: categoryFieldName === "scheduled" ? "0 Mins" : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "0 Mins" : "",
    }));
    onClose();
    setErrorMessage({});
    setError({});
  };

  const handleValidationForRequiredFields = () => {
    let isValid = true;

    if (!itemData.employeename && !setOutsourceDetails) {
      setError((prev) => ({ ...prev, employeename: true }));
      setErrorMessage((prev) => ({ ...prev, employeename: "Employee Name is required" }));
      isValid = false;
    }

    // Check for required fields

    if (localStorage.getItem("roleName")?.toLowerCase() === "technician" && !(categoryFieldName === "scheduled")) {

      if (!itemData.technician && setOutsourceDetails) {
        setError((prev) => ({ ...prev, technician: true }));
        setErrorMessage((prev) => ({ ...prev, technician: "Technician is required" }));
        isValid = false;
      }
      // if (!itemData.startDateandTime) {
      //   setError((prev) => ({ ...prev, startDateandTime: true }));
      //   setErrorMessage((prev) => ({ ...prev, startDateandTime: "Start Date and Time is required" }));
      //   isValid = false;
      // }
      // if (!itemData.endDateandTime) {
      //   setError((prev) => ({ ...prev, endDateandTime: true }));
      //   setErrorMessage((prev) => ({ ...prev, endDateandTime: "End Date and Time is required" }));
      //   isValid = false;
      // }
    }
    return isValid;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    const isValid = handleValidationForRequiredFields();
    if (!isValid) return;

    if (editMode?.dummy_id || editMode?.id) {
      if (editMode?.id) {
        // Update existing row
        const updatedRows = rows.map((row) =>
          row.id === editMode?.id ? itemData : row
        );
        setRows(updatedRows);
      } else if (editMode?.dummy_id) {
        // Update existing row
        const updatedRows = rows.map((row) =>
          row?.dummy_id === editMode?.dummy_id ? itemData : row
        );
        setRows(updatedRows);
      };

      const newUpdatedItem = {
        ...itemData,
        vendorId: RepairType ? "" : vendorId || ""
      };

      dispatch(updateRepairTrackerDetails("UPDATE_REPAIR_TRACKER_DETAILS", { ...newUpdatedItem }));
    } else {

      // Add new row
      const newItem = {
        ...itemData,
        dummy_id: uuidv4(),
        vendorId: RepairType ? "" : vendorId || "",

      };

      dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", { ...newItem }))
      setItemData(initialState);
    }
    onClose();

  };

  useEffect(() => {
    if (editMode?.dummy_id || editMode?.id) {

      if (editMode?.dummy_id) {
        setItemData({
          dummy_id: editMode?.dummy_id || "",
          activity: {
            key: editMode.activity?.key || "",
            label: `${editMode.activity?.label || ""}` || "",
            id: editMode.activity?.id || "",
          },
          employeename: {
            key: editMode.employeename?.key || "",
            label: `${editMode.employeename?.employeename || ""}`,
            id: editMode.employeename?.id || "",
            designation: editMode.employeename?.designation || "",
            employeename: editMode?.employeename?.employeename || "",
            employeecode: editMode?.employeename?.employeecode || ""
          },
          flag: {
            key: editMode.flag?.key || "",
            label: `${editMode.flag?.label || ""}` || "",
            id: editMode.flag?.id || "",
          },
          pic: {
            key: editMode.pic?.key || "",
            label: `${editMode.pic?.label || ""}` || "",
            id: editMode.pic?.id || "",
          },
          preparationHours: editMode?.preparationHours || "",
          remarks: editMode?.remarks || "",
          repairDuration: editMode?.repairDuration || "",
          startDateandTime: editMode?.startDateandTime || "",
          endDateandTime: editMode?.endDateandTime || "",
          verificationHours: editMode?.verificationHours || "",
          technician: editMode?.technician || "",
          vendorId: {
            key: editMode?.vendorId?.key || "",
            id: editMode?.vendorId?.id || "",
            label: editMode?.vendorId?.label || "",
            vendorName: editMode?.vendorId?.label || "",
            vendorCode: editMode?.vendorId?.vendorCode || ""
          },
          id: editMode?.id || "",
        });
      } else if (editMode?.id) {
        setItemData({
          dummy_id: editMode?.dummy_id || "",
          activity: {
            key: editMode.activity?.key || "",
            label: `${editMode.activity?.label || ""}` || "",
            id: editMode.activity?.id || "",
          },
          employeename: {
            key: editMode.employeename?.key || "",
            label: `${editMode.employeename?.employeename || ""}`,
            id: editMode.employeename?.id || "",
            designation: editMode.employeename?.designation || "",
            employeename: editMode?.employeename?.employeename || "",
            employeecode: editMode?.employeename?.employeecode || ""
          },
          flag: {
            key: editMode.flag?.key || "",
            label: `${editMode.flag?.label || ""}` || "",
            id: editMode.flag?.id || "",
          },
          pic: {
            key: editMode.pic?.key || "",
            label: `${editMode.pic?.label || ""}` || "",
            id: editMode.pic?.id || "",
          },
          preparationHours: editMode?.preparationHours || "",
          remarks: editMode?.remarks || "",
          repairDuration: editMode?.repairDuration || "",
          startDateandTime: editMode?.startDateandTime || "",
          endDateandTime: editMode?.endDateandTime || "",
          verificationHours: editMode?.verificationHours || "",
          technician: editMode?.technician || "",
          vendorId: {
            key: editMode?.vendorId?.key || "",
            id: editMode?.vendorId?.id || "",
            label: editMode?.vendorId?.label || "",
            vendorName: editMode?.vendorId?.label || "",
            vendorCode: editMode?.vendorId?.vendorCode || ""
          },
          id: editMode?.id || "",
          timeStamp: editMode?.timeStamp || "",
        });
      }

      setIsFirstRowDisable(editMode?.index === 0 ? true : false);

    } else {
      setItemData((prev) => ({
        employeename: '',
        flag: {},
        pic: {},
        activity: {},
        remarks: "",
        technician: "",
        vendorId: vendorId || "",
        startDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "" : "",
        endDateandTime: categoryFieldName === "scheduled" ? dayjs().format("YYYY-MM-DDTHH:mm:ss") : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "" : "",
        repairDuration: categoryFieldName === "scheduled" ? "0 Mins" : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? "0 Mins" : "",
      }))
      setIsFirstRowDisable(false);

    }
  }, [editMode]);

  const isAddDisabled = categoryFieldName === "scheduled" ?
    (!(itemData?.employeename?.label || itemData?.technician) ||
      !itemData.startDateandTime ||
      !itemData.endDateandTime ||
      error.startDateandTime ||
      error.endDateandTime ||
      itemData.startDateandTime === "" ||
      itemData.endDateandTime === "") :
    (error.startDateandTime ||
      error.endDateandTime);


  return (
    <>
      {/* <PageLoader open={loading} /> */}
      <Dialog
        open={open}
      >
        <DialogTitle>
          <Typography sx={{ fontWeight: "bold", fontSize: "17px" }}>{editMode ? "Edit Repair Tracker" : "Add Repair Tracker"}</Typography>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2}>
            {!setOutsourceDetails && <Grid item xs={6} md={6}>
              <CustomTextFieldWithSearch
                autoFocus={true}
                label="Employee Name"
                id="employeename"
                name="employeename"
                value={itemData?.employeename}
                onChange={handleChangeForRepairTracker}
                options={option?.employeename || []}
                error={error?.employeename}
                errorMessage={errorMessage?.employeename || ""}
                isMandatoryField={true}
              />
            </Grid>}
            {setOutsourceDetails &&
              <>
                {/* <Grid item xs={6} md={6}>
                  <CustomTextField
                    label={"Vendor"}
                    id={"vendor"}
                    name={"vendor"}
                    value={vendorName || ""}
                    onChange={handleChangeForRepairTracker}
                    disabled={true}
                  />
                </Grid> */}
                <Grid item xs={6} md={6}>
                  <CustomTextFieldWithSearch
                    autoFocus={true}
                    label={"Vendor"}
                    id={"vendor"}
                    name={"vendor"}
                    value={vendorId || ""}
                    onChange={handleChangeForRepairTracker}
                    disabled={true}
                  />
                </Grid>
                <Grid item xs={6} md={6}>
                  <CustomTextField
                    label={"Vendor Technician"}
                    id={"technician"}
                    name={"technician"}
                    value={itemData?.technician}
                    onChange={handleChangeForRepairTracker}
                    isMandatoryField={true}
                    error={error?.technician}
                    errorMessage={errorMessage?.technician || ""}
                  />
                </Grid>
              </>
            }
            <Grid item xs={6} md={6}>
              <CustomSelectInput
                label="Flag"
                id="flag"
                name="flag"
                options={option?.flag || []}
                value={itemData?.flag || ""}
                onChange={handleChangeForRepairTracker}
                modal={true}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <CustomSelectInput
                label={"Unit"}
                name="pic"
                value={itemData?.pic || ""}
                onChange={handleChangeForRepairTracker}
                options={option?.pic || []}
                modal={true}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <CustomSelectInput
                label="Activity"
                id="activity"
                name="activity"
                onChange={handleChangeForRepairTracker}
                value={itemData?.activity || ""}
                options={option?.activity || []}
                modal={true}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <CustomDateTimePicker
                label="Start Date and Time"
                onDateChange={(e) => handleChangeForRepairTracker(e, "startDateandTime")}
                value={itemData?.startDateandTime || ""}
                modal={true}
                disableFutureDate={false}
                error={error?.startDateandTime}
                helperText={errorMessage?.startDateandTime}
                displayDefaultValue={false}
                disabled={categoryFieldName === "scheduled" ? false : isFirstRowDisable}
                // isMandatoryField={true}
                // isMandatoryField={categoryFieldName === "scheduled" ? true : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? true : false}
                isMandatoryField={categoryFieldName === "scheduled" ? true : false}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <CustomDateTimePicker
                label="End Date and Time"
                onDateChange={(e) => handleChangeForRepairTracker(e, "endDateandTime")}
                value={itemData?.endDateandTime || ""}
                shouldValidateFutureTime={true}
                modal={true}
                disableFutureDate={false}
                error={error?.endDateandTime}
                helperText={errorMessage?.endDateandTime}
                displayDefaultValue={false}
                // isMandatoryField={true}
                //isMandatoryField={categoryFieldName === "scheduled" ? true : localStorage.getItem("roleName")?.toLowerCase() === "technician" ? true : false}
                isMandatoryField={categoryFieldName === "scheduled" ? true : false}
              />
            </Grid>
            <Grid item xs={6} md={6}>
              <CustomTextField
                label={"Repair Duration"}
                id={"repairDuration"}
                name={"repairDuration"}
                value={itemData?.repairDuration}
                onChange={handleChangeForRepairTracker}
                disabled
              />
              {/* <CustomTimePicker
              label={"Repair Duration in Hrs"}
              id={"repairDuration"}
              name={"repairDuration"}
              value={itemData?.repairDuration}
              onTimeChange={handleChangeForRepairTracker}
              modal={true}
            /> */}

            </Grid>
            <Grid item xs={6} md={6}>
              <CustomTextField
                label={"Remarks"}
                id={"remarks"}
                name={"remarks"}
                value={itemData?.remarks}
                onChange={handleChangeForRepairTracker}
                maxlength={255}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={handleSave} disabled={isAddDisabled}>
            {editMode ? "UPDATE" : "ADD"}
          </Button>
          <Button variant="outlined" onClick={handleCancel}>
            CANCEL
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const Assessments = ({ setPage, page, buttonAttributes }) => {

  //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
  const findHeaderContent = buttonAttributes.find(
    (item) => item.currentPageName === page
  );
  function AddRowButton({ onClick, isDisabled }) {
    return (
      <Box sx={{ mt: 2 }}>
        <Button color="primary" variant="contained" disabled={isDisabled || false} startIcon={<AddIcon />} onClick={onClick}>
          Add Row
        </Button>
      </Box>
    );
  };
  const location = useLocation();
  const viewmode = location.state?.viewmode;
  const status = useSelector((state) => state?.workOrderStatus?.status);
  const assessmentsMandatoryFields = useSelector((state) => state.workOrdermandatoryFields.assessmentsMandatoryFields);
  const assetCategoryType = useSelector((state) => state?.serviceType);
  const basicDetails = useSelector((state) => state.workOrderBasicDetails);
  const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const token = getAuthToken("id_token");
  const dispatch = useDispatch();
  const companyId = getcompanyId('companyId');
  const roleName = localStorage.getItem("roleName")?.toLowerCase();
  const userId = localStorage.getItem("UserId");
  const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
  const assessments = basicDetails?.assessments || {};
  const categoryType = assetCategoryType?.category;
  const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
  const repairCategoryFieldName = categoryType === "Scheduled" ? "sch" : "usch";
  const setScheduledField = categoryType === "Scheduled" ? true : false;
  const repairTrackerRows = basicDetails?.assessments?.repairTracker || [];
  const setOutsourceDetails = basicDetails?.vendorField;  // Or fallback value if needed
  let employeeDetails = [];

  const [outSourceDialog, setOutSourceDialog] = useState(false);
  const [gridAPI, setGridApi] = useState({});
  const [assessmentsdata, setAssessmentsData] = useState(assessments || {});
  const [rows, setRows] = useState(repairTrackerRows || []);
  const [deleteRows, setDeleteRows] = useState([]);
  const [isOnchange, setIsOnchange] = useState(false);
  const [empFieldDisable, setEmpFieldDisabled] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorDialogMssg, setErrorDialogMssg] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    respondedBy: "",
    respondedStartDateandTime: "",
    respondedEndDateandTime: "",
    taskCode: "",
    repairType: "",
    repairTrackerRows: "",
    vendor: "",
    respondedFinding: ""
  });
  const [error, setError] = useState({
    respondedBy: false,
    respondedStartDateandTime: false,
    respondedEndDateandTime: false,
    taskCode: false,
    repairType: false,
    repairTrackerRows: false,
    vendor: false,
    respondedFinding: false
  });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [deleteDialog, setDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [option, setOption] = useState({
    respondedBy: [],
    taskCode: [],
    vendor: []
  });
  const [editData, setEditData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [scheduled, setScheduled] = useState(setScheduledField);
  const [disableRespondBy, setDisableRespondBy] = useState(false);
  const isFormSubmitButton = true;
  let outsourceRows = [];
  let inHouseRows = [];
  const isTechnicianRole = (roleName === "technician" ? true : false);
  const now = new Date();
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();
  const day = now.getDay(); // Sunday = 0, Saturday = 6

  // Check if current time is within 08:00 to 17:30
  const isWithinDayShift = (currentHour > 8 && currentHour < 17) ||
    (currentHour === 8) ||
    (currentHour === 17 && currentMinute <= 30);

  // Check if current time is *outside* 08:00 to 17:30
  const isOutsideDayShift = !isWithinDayShift;

  const isWeekend = day === 6 || day === 0;

  //const disableRespondBy = (roleName ==="Technician") && !(isWeekend || isOutsideDayShift);

  const statusMapping = {
    "Open": 1,
    "In Progress": 3,
    "Completed": 4,
    "Closed": 5,
    "Cancelled": 6,
    "Verified": 8,
    "Not Done and Closed": 7,
    "Completed-Outsource": 9,
    "In Progress-Outsource": 10

  };

  // Map the current status to the corresponding number
  const mappedStatus = statusMapping[status] || null; // If status doesn't exist, fallback to null or any default value

  //For RepairTracker Grid Rows
  const shouldEnableDeleteAndEdit = categoryType === "Scheduled" ? !viewmode && mappedStatus !== 6 && mappedStatus !== 7 && mappedStatus !== 5 :
    roleName === "technician" ? !viewmode && mappedStatus !== 4 && mappedStatus !== 8 && mappedStatus !== 9 && mappedStatus !== 6 && mappedStatus !== 7 && mappedStatus !== 5 :
      !viewmode && mappedStatus !== 6 && mappedStatus !== 7 && mappedStatus !== 5;
  // const isMandatoryField = categoryType === "UnScheduled"  ?!scheduled && mappedStatus !== 5 && ( roleName === "technician"): true;
  const isMandatoryField = !scheduled && mappedStatus !== 5 && (roleName === "technician");

  const formatDate = (dateString) => {
    if (!dateString) {
      return '';
    };
    const formattedDate = format(new Date(dateString), 'dd/MM/yyyy HH:mm:ss'); // Format the date as 'dd/MM/yyyy HH:mm:ss'
    return formattedDate;
  };

  const checkBtnDisable = categoryType === "Scheduled" ? false : !isTechnicianRole ? false : ((isTechnicianRole && assessmentsdata?.respondedEndDateandTime && assessmentsdata?.taskCode?.id && assessmentsdata?.respondedFinding) ? false : true)


  const columns_Field = [
    ...(setOutsourceDetails || !!(assessmentsdata?.repairType === "Outsource")
      ? [
        { field: 'vendorId', headerName: 'Vendor', flex: 1, valueGetter: (params) => params?.data ? params?.data?.vendorId?.vendorName || params?.data?.vendorId?.label || "" : "" },
        { field: 'technician', headerName: 'Vendor Technician', flex: 1 },
      ]
      : [
        {
          field: 'employeeName',
          headerName: 'Employee Name',
          flex: 1,
          minWidth: isSmallScreen ? 150 : 200,
          valueGetter: (params) => params?.data?.employeename ? params?.data.employeename?.employeename : '',
        }
      ]
    ),
    {
      field: 'flag',
      headerName: 'Flag',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => params?.data?.flag ? params?.data.flag?.label : '',
    },
    {
      field: 'pic',
      headerName: 'Unit',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => params?.data?.pic ? params?.data.pic?.label : '',
    },
    {
      field: 'activity',
      headerName: 'Activity',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => params?.data?.activity ? params?.data.activity?.label : '',
    },
    {
      field: 'startDateandTime',
      headerName: 'Start Date/Time ',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => formatDate(params?.data?.startDateandTime),
    },
    {
      field: 'endDateandTime',
      headerName: 'End Date/Time ',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
      valueGetter: (params) => formatDate(params?.data?.endDateandTime),
    },
    {
      field: 'repairDuration',
      headerName: 'Repair Duration',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      flex: 1,
      minWidth: isSmallScreen ? 80 : 120,
    }
  ];

  useMemo(() => {
    rows.forEach((row) => {
      if (row?.employeename?.id) {
        inHouseRows.push(row);
      } else {
        outsourceRows.push(row);
      }
    });
    return { outsourceRows, inHouseRows };
  }, [outsourceRows, inHouseRows, rows])

  useEffect(() => {
    setRows(repairTrackerRows || [])
    if (repairTrackerRows?.length > 0) {
      setError((prev) => ({
        ...prev,
        repairTrackerRows: false,
      }));

      setErrorMessage((prev) => ({
        ...prev,
        repairTrackerRows: ""
      }))
    }

  }, [repairTrackerRows])

  const getStepper = useSelector((state) => state?.checkParts);
  const withPartsRequired = getStepper;
  const withoutPartsRequired = getStepper?.filter((item) => item?.label !== 'Part Replacement');

  const handleOnchange = async (value, name) => {
    setAssessmentsData((previous) => {
      const updatedData = {
        ...previous,
        [name]: value,
      };

      if (name === "respondedBy") {
        if (value?.id) {
          updatedData.respondedBy = { ...value, label: value?.employeename };
          updatedData.designation = value?.designation;
        } else {
          updatedData.respondedBy = "";
          updatedData.designation = "";
        }
      };

      if (name === "taskCode") {
        if (value?.id) {
          updatedData.taskCode = { ...value, label: value?.taskCode }
          updatedData.taskDescription = value?.taskDesc;
        } else {
          updatedData.taskCode = "";
          updatedData.taskDescription = "";
        }
      };

      if (name === "partsRequired") {
        if (value?.label === 'No') {
          dispatch(updateAssessmentsPartsRequired("UPDATE_ASSESSMENTS_PARTS_REQUIRED_CHANGED", withoutPartsRequired));
          // setPageName("Completion Info");
        } else {
          dispatch(updateAssessmentsPartsInitialState("UPDATE_ASSESSMENTS_PARTS_REQUIRED_INITIALSTATE", withPartsRequired));
          // setPageName("Part Replacement");
        }
      };

      if (name === 'repairType') {
        setIsOnchange(true);
        dispatch(updateOutsourceDetails("SET_VENDORFIELD", value === 'Outsource' ? true : false));
        // if (value === 'Outsource') {
        //   updatedData.vendor = { id: "", label: "" };
        //   // updatedData.respondedBy = { id: "", label: "" };
        //   // updatedData.designation = "";

        //   setDeleteRows(rows || []);
        //   // Dispatch action to clear repair tracker
        //   dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));

        //   setError((prev) => ({
        //     ...prev,
        //     repairTrackerRows: false,
        //     // respondedBy: false
        //   }));

        //   setErrorMessage((prev) => ({
        //     ...prev,
        //     repairTrackerRows: "",
        //     // respondedBy: ""
        //   }))

        // } else
        //   setDeleteRows(rows || []);
        // // Dispatch action to clear repair tracker
        // dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
        // updatedData.vendor = { id: "", label: "" };

        // setError((prev) => ({
        //   ...prev,
        //   repairTrackerRows: false
        // }));

        // setErrorMessage((prev) => ({
        //   ...prev,
        //   repairTrackerRows: ""
        // }))

      };

      // if (name === "vendor") {
      //   setAssessmentsData((previousValue) => {
      //     const currentVendor = previousValue.vendor?.id || ""; // Get the current vendor ID
      //     const newVendor = value?.id || ""; // Get the new vendor ID

      //     // Check if the vendor has changed
      //     if (currentVendor !== newVendor && !isOnchange) {
      //       setDeleteRows(rows || []);
      //       // Dispatch action to clear repair tracker
      //       dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));

      //       return {
      //         ...previousValue,
      //         vendor: value || { id: "", label: "" }, // Update the vendor field
      //       };
      //     } else {
      //       return previousValue; // Return unchanged state if the vendor hasn't changed
      //     }
      //   });
      // };

      return updatedData;
    });



    const workOrderDateAndTime = basicDetails?.workorderDateandTime;
    if (name === 'respondedStartDateandTime' && value && workOrderDateAndTime) {
      const workOrderDate = new Date(workOrderDateAndTime);
      const selectedDate = new Date(value);
      const endDate = new Date(assessmentsdata?.respondedEndDateandTime);

      if (selectedDate < workOrderDate) {
        setError((prev) => ({
          ...prev,
          respondedStartDateandTime: true
        }));

        setErrorMessage((prev) => ({
          ...prev,
          respondedStartDateandTime: "Responded Start date and time should be greater than the work order date and time."
        }));
        return;
      } else {
        setError((prev) => ({
          ...prev,
          respondedStartDateandTime: false
        }));
        setErrorMessage((prev) => ({
          ...prev,
          respondedStartDateandTime: ""
        }));

      }

      // Check if the end date is before the start date
      if (endDate && selectedDate > endDate) {
        setError(prevErrors => ({
          ...prevErrors,
          respondedEndDateandTime: true,
        }));
        setErrorMessage(prevErrorMessages => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "Responded End date and time should be greater than the Responded Start date and time.",
        }));
      } else if (error.respondedEndDateandTime) {
        setError(prevErrors => ({
          ...prevErrors,
          respondedEndDateandTime: false,
        }));
        setErrorMessage(prevErrorMessages => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "",
        }));
      };
    };

    if (name === 'respondedEndDateandTime' && value) {
      const respondStartdateandTime = new Date(assessmentsdata?.respondedStartDateandTime);
      const selectedDate = new Date(value);
      if (selectedDate < respondStartdateandTime) {
        setError({
          ...error,
          respondedEndDateandTime: true,
        });
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "Responded End date and time should be greater than the Response Start date and time.",
        }));
        return;
      } else {
        setError((prevErrors) => ({
          ...prevErrors,
          respondedEndDateandTime: false,
        }));
        setErrorMessage((prevErrorMessages) => ({
          ...prevErrorMessages,
          respondedEndDateandTime: "",
        }));
      };
    };

    setError((prev) => {
      const updatedError = {
        ...prev,
        [name]: false
      };
      return updatedError;
    });

    setErrorMessage((prev) => ({
      ...prev,
      [name]: ''
    }));
  };

  const handleRepairTypeChange = (event) => {
    handleOnchange(event.target.value, "repairType");
  };

  const memoizedDetails = useMemo(() => ({
    respondedBy: assessmentsdata?.respondedBy || '',
    respondedStartDateandTime: assessmentsdata?.respondedStartDateandTime || '',
    taskCode: assessmentsdata?.taskCode || '',
    repairType: assessmentsdata?.repairType || '',
    vendor: assessmentsdata?.vendor || "",
    respondedFinding: assessmentsdata?.respondedFinding || '',
    respondedEndDateandTime: assessmentsdata?.respondedEndDateandTime || ''

  }), [
    assessmentsdata?.respondedBy,
    assessmentsdata?.respondedStartDateandTime,
    assessmentsdata?.taskCode,
    assessmentsdata?.repairType,
    assessmentsdata?.vendor,
    assessmentsdata?.respondedFinding,
    assessmentsdata?.respondedEndDateandTime

  ]);

  //function to check the mandatory field are filled or not(responsible for green ticks on left side)
  const checkMandatoryValueFilled = useCallback(debounce((
    respondedBy,
    respondedStartDateandTime,
    taskCode,
    repairType,
    vendor,
    respondedFinding,
    respondedEndDateandTime
  ) => {
    const updateStatus = (type, value, name, isVisible, errorState) => ({
      type,
      valueFilled: !errorState && !!value,
      name,
      isVisible
    });

    const updateRespondedBy = updateStatus((scheduled ? "Assignee" : "Responded By"), respondedBy, 'respondedBy', !(scheduled && setOutsourceDetails), error.respondedBy);
    const updateRespondedStartDateandTime = updateStatus("Response Start Date & Time", respondedStartDateandTime, 'respondedStartDateandTime', !scheduled, error.respondedStartDateandTime);
    const updateTaskCode = updateStatus("Task Code", taskCode, 'taskCode', true, error.taskCode);
    const updaterepairType = updateStatus("Repair Type", repairType, 'repairType', true, error.repairType);
    const updateVendor = updateStatus("Vendor", vendor, 'vendor', setOutsourceDetails, error.vendor);
    const updateRespondFinding = updateStatus("Responded Finding", respondedFinding, 'respondedFinding', (!scheduled), error.respondedFinding);
    const updateRespondEndDateandTime = updateStatus("Responded Start Date & Time", respondedEndDateandTime, 'respondedEndDateandTime', (!scheduled), error.respondedEndDateandTime);

    let arrayAfterUpdating = [
      //  updateTaskCode,
      updaterepairType,
    ];

    if (!(scheduled && setOutsourceDetails)) {
      arrayAfterUpdating.push(updateRespondedBy)
    };

    if (setOutsourceDetails) {
      arrayAfterUpdating?.push(updateVendor)
    };

    if (!scheduled) {
      arrayAfterUpdating.push(updateRespondedStartDateandTime)
    }

    if (categoryType === "Unscheduled" && isMandatoryField) {
      arrayAfterUpdating.push(updateRespondFinding)
      arrayAfterUpdating.push(updateTaskCode)
      arrayAfterUpdating.push(updateRespondEndDateandTime)
    }
    else if (categoryType === "Scheduled") {
      arrayAfterUpdating.push(updateTaskCode)
    }


    if (arrayAfterUpdating !== undefined && arrayAfterUpdating.every(item => item !== undefined)) {
      dispatch({ type: "UPDATE_WORK_ORDER_ASSESMENTS_MANDATORY_FIELDS", payload: arrayAfterUpdating })
    }
  }), [dispatch, error, setOutsourceDetails]);

  useEffect(() => {
    const {
      respondedBy,
      respondedStartDateandTime,
      taskCode,
      repairType,
      vendor,
      respondedFinding,
      respondedEndDateandTime
    } = memoizedDetails;
    checkMandatoryValueFilled(
      respondedBy?.id,
      respondedStartDateandTime,
      taskCode?.id,
      repairType,
      vendor?.id,
      respondedFinding,
      respondedEndDateandTime
    );
  }, [
    memoizedDetails,
    checkMandatoryValueFilled
  ]);

  const handleValidationForRequiredFields = () => {
    let isValid = true;

    // Check if any error state is true
    if (Object.values(error).some((value) => value === true)) {
      isValid = false;
    }

    assessmentsMandatoryFields.forEach((item) => {
      if (item.valueFilled === false && !error[item.name]) {
        setError((prev) => ({
          ...prev,
          [item.name]: true,
        }));
        setErrorMessage((prev) => ({
          ...prev,
          [item.name]: `${item.type} is required `,
        }));

        isValid = false;
      }
    });

    //  if (repairTrackerRows <= 0 && !setOutsourceDetails) {
    if (categoryType === "Unscheduled" ? (repairTrackerRows <= 0 && isMandatoryField) : (repairTrackerRows <= 0)) {
      setError((prev) => ({
        ...prev,
        repairTrackerRows: true,
      }));
      setErrorMessage((prev) => ({
        ...prev,
        repairTrackerRows: "Please add at least one repair tracker row",
      }));
      isValid = false;
    }

    return isValid;
  };

  const getEmpNameForAutoAssign = async () => {
    const employeeResponse = await workOrderSummaryRepositry.fetchEmployeeDetails();

    const mapEmployeeIdToName = (id) => {
      const employee = employeeResponse?.find(emp => emp?.id === id);
      // const employee = employeeResponse?.find(emp => emp?.userid === id);
      return employee ? employee?.employeename : '';
    };

    const mapEmployeeIdToDesignation = (id) => {
      const employee = employeeResponse?.find(emp => emp?.id === id);
      // const employee = employeeResponse?.find(emp => emp?.userid === id);
      return employee ? employee?.designation : '';
    };

    const mapEmployeeIdToCode = (id) => {
      const employee = employeeResponse?.find(emp => emp?.id === id);
      return employee ? employee?.employeecode : '';
    };
    if (!assessments?.id) {
      try {

        const empNameResponse = await workOrderSummaryRepositry.autoAssignedEmp(serviceType, basicDetails?.id);
        empNameResponse?.map((item) => {
          if (item?.id) {
            setAssessmentsData((prev) => ({
              ...prev,
              respondedBy: {
                id: item?.respondedbyid,
                label: mapEmployeeIdToName(item?.respondedbyid),
                employeecode: mapEmployeeIdToCode(item?.respondedbyid)
              },
              designation: mapEmployeeIdToDesignation(item?.respondedbyid),
              respondedStartDateandTime: item?.respondedstartdate
            }));
            setEmpFieldDisabled(true);
          }
          return null; // to ensure map returns an array, although it's not used here
        });
      } catch (error) {
        console.error(error);
      }
    }
  }


  useEffect(() => {
    setAssessmentsData((previousValue) => {
      return {
        ...previousValue,
        vendor: assessments?.vendor || ''

      }
    });

    setScheduled(setScheduledField);

  }, [basicDetails?.editmode, empFieldDisable])

  const fetchOptions = async () => {
    const respondedBy = await workOrderSummaryRepositry.fetchEmployeeDetails();

    const mappedEmployees = respondedBy?.map((item, index) => ({
      key: `option${index}`,
      label: `${item?.employeecode || ""} - ${item?.employeename || ""}`,
      employeename: item?.employeename || "",
      employeecode: item?.employeecode || "",
      designation: item?.designation || "",
      empservice: item?.empservice || "",
      id: item?.id,
      userId: item?.userid || "" // Added userid to the mapped object
    }));

    employeeDetails = mappedEmployees;

    setOption((previous) => ({
      ...previous,
      respondedBy: mappedEmployees,
    }));

    if (!scheduled) {
      let workGroupId = basicDetails?.workGroupId || basicDetails?.assetNo?.workGroupId || basicDetails?.referenceWorkRequestNo?.workGroupId || "";

      const taskCode = await workOrderSummaryRepositry.fetchTaskCode(serviceType, workGroupId);
      setOption((previous) => ({
        ...previous,
        taskCode: taskCode?.map((item, index) => ({
          key: `option${index}`,
          label: `${item?.taskcode || ""} - ${item?.taskdesc || ""}` || "",
          taskCode: item?.taskcode || "",
          taskDesc: item?.taskdesc || "",
          serviceName: item?.service || "",
          wgCode: item?.wgcode || "",
          wgDesc: item?.wgdesc || "",
          wgId: item?.wgId || "",
          id: item?.id || "",

        }))
      }));
    };


    const vendorOptions = await workOrderSummaryRepositry.fetchVendorDetails();
    setOption((previous) => ({
      ...previous,
      vendor: vendorOptions?.map((details, index) => ({
        key: `option${index}`,
        label: details?.vendorname || "",
        vendorName: details?.vendorname || "",
        vendorcode: details?.vendorcode || "",
        vendoremail: details?.vendoremail || "",
        serviceCode: details?.servicecode || "",
        id: details?.id
      }))
    }))
  };

  const handleOutsourceSubmit = () => {
    setOutSourceDialog(false);
  };

  const handleDelete = (row) => {
    setDeleteDialog(true);
    setDeleteId(row)
  };

  const handleCloseCancelDialog = () => {
    setDeleteDialog(false);
  };

  const handleConfirmDelete = async () => {
    try {
      await workOrderSummaryRepositry.deleteRepairTracker(serviceType, categoryType, deleteId?.id);

      let updatedRows = [];

      if (deleteId?.id) {
        updatedRows = rows?.filter((row) => row?.id !== deleteId?.id);
        setRows(updatedRows);
        dispatch({ type: 'DELETE_REPAIR_TRACKER', payload: { id: deleteId?.id } });
        setDeleteDialog(false);
      } else if (deleteId?.dummy_id) {
        updatedRows = rows?.filter((row) => row?.dummy_id !== deleteId?.dummy_id);
        setRows(updatedRows);
        dispatch({ type: 'DELETE_REPAIR_TRACKER', payload: { dummy_id: deleteId?.dummy_id } });
        setDeleteDialog(false);
      };

    } catch (error) {
      console.error(error);
    }
  };



  // console.log(rows, "rows======>");

  const handleSubmitContinueButton = async (event, checkIsFormSubmitButton) => {
    setLoading(true);
    if (event?.preventDefault) {
      event.preventDefault();
    }
    const isValid = handleValidationForRequiredFields();

    if (!viewmode && mappedStatus !== 6 && mappedStatus !== 7 && isValid) {

      const employeeName = await workOrderSummaryRepositry.fetchEmployeeDetails();
      const lovOptions = await workOrderSummaryRepositry.lovOptions();
      const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();

      const mapEmpCode = (id) => {
        const empCode = employeeName?.find(empc => empc.id === id);
        return empCode ? empCode.employeecode : '';
      };

      const mapEmpName = (id) => {
        const empCode = employeeName?.find(empN => empN.id === id);
        return empCode ? empCode.employeename : '';
      };

      const mapFlagDesc = (id) => {
        const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
        return flagDesc ? flagDesc?.repairflag : '';
      };

      const mapPicDesc = (id) => {
        const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
        return picDesc ? picDesc?.repairpic : '';
      };

      const mapActivityDesc = (id) => {
        const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
        return activityDesc ? activityDesc?.repairactivity : '';
      };

      const maptoVendorDetails = (id) => {
        const vendor = vendorDetails?.find(v => v?.id === id);
        return vendor ? vendor?.vendorname : '';
      };

      const maptoVendorCode = (id) => {
        const vendor = vendorDetails?.find(v => v?.id === id);
        return vendor ? vendor?.vendorcode : '';
      };

      if (basicDetails?.assessments?.id) {

        const updatePayload = {
          respondedbyid: assessmentsdata?.respondedBy?.id || "",
          responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
          responseenddate: assessmentsdata?.respondedEndDateandTime || "",
          assessmenthrs: "",
          respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
          respondfinding: assessmentsdata?.respondedFinding || "",
          ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
          isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
         [`${serviceType}decontaminationnoticeId`]: assessmentsdata?.decontaminationNotice?.label === "Passed" ? 1 : assessmentsdata?.decontaminationNotice?.label === "Not Passed" ? 2 : "",
          vendorid: assessmentsdata?.vendor?.id || "",
          Respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
          // [`${serviceType}worespondtypeId`]: mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 8 || mappedStatus === 9 ? basicDetails?.assessments?.repairType === "Inhouse" ? 2 : 1 : assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
          [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
          id: assessments?.id || "",
          timestamp: assessmentsdata?.timeStamp || "",
          isrespond: basicDetails?.isresponse === "Yes" ? 1 : "",
          token: token
        };

        //  console.log("Original rows:", rows);

        // console.log(outsourceRows, "outsourceRows");
        // console.log(assessmentsdata?.repairType, "assessmentsdata?.repairType");
        // console.log(outsourceRows?.length, "outsourceRows==>");
        // console.log(outsourceRows?.length <= 0, "outsourceRows?.length < 0");
        // console.log(assessmentsdata?.repairType === "Outsource" && outsourceRows?.length <= 0, "===================>");


        // let updateRepairDetailsPayload = [];

        // // Common mapping function for existing rows
        // const mappedRowsPayload = rows?.map((row, index) => {
        //   let repairstartdateValue = row?.startDateandTime || "";

        //   if (index === 0 && (!row?.endDateandTime || row?.endDateandTime.trim() === "")) {
        //     repairstartdateValue = assessmentsdata?.respondedEndDateandTime || "";
        //   }

        //   return {
        //     employeeid: row?.employeename?.id || "",
        //     repairstartdate: repairstartdateValue,
        //     repairenddate: row?.endDateandTime || "",
        //     repairduration: row?.repairDuration || "",
        //     preparationhours: row?.preparationHours || "",
        //     verificationhours: row?.verificationHours || "",
        //     remarks: row?.remarks || "",
        //     vendorid: row?.vendorId?.id || assessmentsdata?.vendor?.id || "",
        //     Vendortechnician: row?.technician || "",
        //     [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
        //     [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
        //     [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
        //     [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
        //     [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
        //     id: row?.id || "",
        //     timestamp: row?.timeStamp || ""
        //   };
        // });

        // // Outsource default payload
        // const defaultOutsourcePayload = {
        //   employeeid: "",
        //   repairstartdate: "",
        //   repairenddate: "",
        //   repairduration: "",
        //   preparationhours: "",
        //   verificationhours: "",
        //   remarks: "",
        //   vendorid: assessmentsdata?.vendor?.id || "",
        //   Vendortechnician: "",
        //   [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
        //   [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
        //   [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
        //   [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
        //   id: "",
        //   timestamp: ""
        // };

        // // Inhouse default payload
        // const defaultInhousePayload = {
        //   employeeid: assessmentsdata?.respondedBy?.id || "",
        //   repairstartdate: assessmentsdata?.respondedEndDateandTime || "",
        //   repairenddate: "",
        //   repairduration: "",
        //   preparationhours: "",
        //   verificationhours: "",
        //   remarks: "",
        //   Vendortechnician: "",
        //   vendorid: "",
        //   [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
        //   [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
        //   [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
        //   [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
        //   id: "",
        //   timestamp: ""
        // };

        // // Logic for combining payloads
        // if (assessmentsdata?.repairType === "Outsource" && outsourceRows?.length <= 0) {
        //   updateRepairDetailsPayload = [defaultOutsourcePayload, ...mappedRowsPayload];
        // }
        // else if (assessmentsdata?.repairType === "Inhouse" && inHouseRows?.length <= 0) {
        //   updateRepairDetailsPayload = [defaultInhousePayload, ...mappedRowsPayload];
        // }
        // else {
        //   updateRepairDetailsPayload = mappedRowsPayload;
        // }

        // console.log("Final payload:", updateRepairDetailsPayload);

        let updateRepairDetailsPayload = [];

        // Common mapping function for existing rows
        const firstNullVendorIndex = rows?.findIndex(r => !r?.vendorId?.id);

        const mappedRowsPayload = rows?.map((row, index) => {
          let repairstartdateValue = row?.startDateandTime || assessmentsdata?.respondedEndDateandTime || "";
          let employeeIdValue = row?.employeename?.id || "";
          let vendorIdValue = row?.vendorId?.id || "";

          // ✅ Special override ONLY for first Inhouse row with vendorid null
          if (
            assessmentsdata?.repairType === "Inhouse" &&
            index === firstNullVendorIndex &&   // only first null-vendor row
            (!row?.endDateandTime || row?.endDateandTime.trim() === "")
          ) {
            repairstartdateValue = assessmentsdata?.respondedEndDateandTime || "";
            employeeIdValue = assessmentsdata?.respondedBy?.id || ""; // if needed
          }

          return {
            employeeid: employeeIdValue,
            repairstartdate: repairstartdateValue,
            repairenddate: row?.endDateandTime || "",
            repairduration: row?.repairDuration || "",
            preparationhours: row?.preparationHours || "",
            verificationhours: row?.verificationHours || "",
            remarks: row?.remarks || "",
            vendorid: vendorIdValue,
            Vendortechnician: row?.technician || "",
            [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
            [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
            id: row?.id || "",
            timestamp: row?.timeStamp || ""
          };
        });

        // Outsource default payload
        const defaultOutsourcePayload = {
          employeeid: "",
          repairstartdate: "",
          repairenddate: "",
          repairduration: "",
          preparationhours: "",
          verificationhours: "",
          remarks: "",
          vendorid: assessmentsdata?.vendor?.id || "",
          Vendortechnician: "",
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
          [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
          id: "",
          timestamp: ""
        };

        // Inhouse default payload (✅ vendorid now matches requirement)
        const defaultInhousePayload = {
          employeeid: assessmentsdata?.respondedBy?.id || "",
          repairstartdate: assessmentsdata?.respondedEndDateandTime || "",
          repairenddate: "",
          repairduration: "",
          preparationhours: "",
          verificationhours: "",
          remarks: "",
          Vendortechnician: "",
          vendorid: "", // ✅ fixed here too
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
          [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
          id: "",
          timestamp: ""
        };

        // Logic for combining payloads

        const isMappedStatusSpecial = [4, 5, 8, 9].includes(mappedStatus);
        if (isMappedStatusSpecial) {
          updateRepairDetailsPayload = mappedRowsPayload;
        }
        else if (assessmentsdata?.repairType === "Inhouse" && inHouseRows?.length <= 0) {
          updateRepairDetailsPayload = [defaultInhousePayload, ...mappedRowsPayload];
        } else if (assessmentsdata?.repairType === "Outsource" && outsourceRows?.length <= 0) {
          updateRepairDetailsPayload = [defaultOutsourcePayload, ...mappedRowsPayload];
        }
        else {
          updateRepairDetailsPayload = mappedRowsPayload;
        }


        // const updateRepairDetailsPayload = rows?.map((row) => ({
        //   employeeid: row?.employeename?.id || "",
        //   repairstartdate: row?.startDateandTime || "",
        //   repairenddate: row?.endDateandTime || "",
        //   repairduration: row?.repairDuration || "",
        //   preparationhours: row?.preparationHours || "",
        //   verificationhours: row?.verificationHours || "",
        //   remarks: row?.remarks || "",
        //   Vendortechnician: row?.technician || "",
        //   vendorid: row?.vendorId?.id || "",
        //   [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
        //   [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
        //   id: row?.id || "",
        //   timestamp: row?.timeStamp || ""
        // }));

        const assesmentsId = basicDetails?.assessments?.id || "";
        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));
        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                workOrderSummaryRepositry.deleteRepairTracker(
                  serviceType,
                  categoryType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }
        const updateAssessmentDetailsResponse = await workOrderSummaryRepositry.updateAssessmentsDetails(serviceType, updatePayload, categoryType,);
        if (updateRepairDetailsPayload?.length > 0) {
          const updateRepairTracker = await workOrderSummaryRepositry.updateRepairTracker(serviceType, updateRepairDetailsPayload, categoryType, assesmentsId);

          updateRepairTracker?.forEach((row, index) => {
            const transformedObject = {
              employeename: {
                employeeCode: mapEmpCode(row?.employeeid || ""),
                employeename: mapEmpName(row?.employeeid || ""),
                id: row?.employeeid || "",
              },
              flag: {
                id: row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "",
                label: mapFlagDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "")
              },
              pic: {
                id: row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "",
                label: mapPicDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "")
              },
              activity: {
                id: row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "",
                label: mapActivityDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "")
              },
              vendorId: {
                id: row?.vendorid || "",
                label: maptoVendorDetails(row?.vendorid || ""),
                vendorName: maptoVendorDetails(row?.vendorid || ""),
                vendorCode: maptoVendorCode(row?.vendorid || "")
              },
              technician: row?.vendortechnician || "",
              startDateandTime: row?.repairstartdate || "",
              endDateandTime: row?.repairenddate || "",
              repairDuration: row?.repairduration || "",
              preparationHours: row?.preparationhours || "",
              verificationHours: row?.verificationhours || "",
              remarks: row?.remarks || "",
              id: row?.id || "",
              timeStamp: row?.timestamp || "",
              index: index
            };
            dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
          });
        };


        const checkStatus = processingPercentage > 70 ? status : (assessmentsdata?.repairType === "Inhouse") ? statusList?.inProgress?.label : statusList?.inProgressOutsource?.label;

        if (updateAssessmentDetailsResponse?.id) {
          // const newPayload = {
          //   ...assessmentsdata, // current state
          //   repairType: basicDetails?.assessments?.repairType || assessmentsdata?.repairType
          // };

          // const reduxpayload = mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 8 || mappedStatus === 9 ?
          //   { newPayload } : { assessmentsdata }

          dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: updateAssessmentDetailsResponse?.id || "", timeStamp: updateAssessmentDetailsResponse?.timestamp || "" }));
          dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: checkStatus, percentage: processingPercentage }));
          if (!checkIsFormSubmitButton) {
            setPage("Attachments")
          }
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
          setOutSourceDialog(true);

        } else if (updateAssessmentDetailsResponse?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${updateAssessmentDetailsResponse?.response?.data?.detail}`)
        }
        else if (updateAssessmentDetailsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }
      }

      else {
        const APIPayload = {
          respondedbyid: assessmentsdata?.respondedBy?.id || "",
          responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
          responseenddate: assessmentsdata?.respondedEndDateandTime || "",
          assessmenthrs: "",
          respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
          respondfinding: assessmentsdata?.respondedFinding || "",
          ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
          isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
          [`${serviceType}decontaminationnoticeId`]: assessmentsdata?.decontaminationNotice?.label === "Passed" ? 1 : assessmentsdata?.decontaminationNotice?.label === "Not Passed" ? 2 : "",
          vendorid: assessmentsdata?.vendor?.id || "",
          Respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
          [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
          token: token
        };

        const createAssessmentsResponse = await workOrderSummaryRepositry.addAssessmentsDetails(serviceType, APIPayload, categoryType);

        const repairDetailsPayload = (categoryType === "Unscheduled" && !isTechnicianRole && rows.length <= 0) ?
          [
            {
              employeeid: assessmentsdata?.repairType === "Inhouse" ? assessmentsdata?.respondedBy?.id || "" : "",
              repairstartdate: assessmentsdata?.respondedEndDateandTime || "",
              repairenddate: "",
              repairduration: "",
              preparationhours: "",
              verificationhours: "",
              remarks: "",
              Vendortechnician: "",
              vendorid: assessmentsdata?.repairType === "Inhouse" ? "" : assessmentsdata?.vendor?.id || "",
              [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
              [`${serviceType}${categoryFieldName}woassessmentheaderId`]: createAssessmentsResponse?.id || "",
              [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
              [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
              [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
              id: "",
              timestamp: ""
            }
          ]
          :
          rows?.map((row) => ({
            employeeid: row?.employeename?.id || "",
            repairstartdate: categoryType === "Unscheduled" ? (assessmentsdata?.respondedEndDateandTime || rows?.startDateandTime || "") : (row?.startDateandTime || ""),
            repairenddate: row?.endDateandTime || "",
            repairduration: row?.repairDuration || "",
            preparationhours: row?.preparationHours || "",
            verificationhours: row?.verificationHours || "",
            remarks: row?.remarks || "",
            vendorid: row?.vendorId?.id || "",
            Vendortechnician: row?.technician || "",
            [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
            [`${serviceType}${categoryFieldName}woassessmentheaderId`]: createAssessmentsResponse?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
            id: row?.id || "",
            timestamp: row?.timeStamp || ""
          }));

        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []))
        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                workOrderSummaryRepositry.deleteRepairTracker(
                  serviceType,
                  categoryType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }

        const saveRepairTracker = await workOrderSummaryRepositry.addRepairTracker(serviceType, repairDetailsPayload, categoryType);

        saveRepairTracker?.forEach((row, index) => {
          const transformedObject = {
            employeename: {
              employeeCode: mapEmpCode(row?.employeeid || ""),
              employeename: mapEmpName(row?.employeeid || ""),
              id: row?.employeeid || "",
            },
            flag: {
              id: row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "",
              label: mapFlagDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "")
            },
            pic: {
              id: row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "",
              label: mapPicDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "")
            },
            activity: {
              id: row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "",
              label: mapActivityDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "")
            },
            vendorId: {
              id: row?.vendorid || "",
              label: maptoVendorDetails(row?.vendorid || ""),
              vendorName: maptoVendorDetails(row?.vendorid || ""),
              vendorCode: maptoVendorCode(row?.vendorid || "")

            },
            technician: row?.vendortechnician || "",
            startDateandTime: row?.repairstartdate || "",
            endDateandTime: row?.repairenddate || "",
            repairDuration: row?.repairduration || "",
            preparationHours: row?.preparationhours || "",
            verificationHours: row?.verificationhours || "",
            remarks: row?.remarks || "",
            id: row?.id || "",
            timeStamp: row?.timestamp || "",
            index: index
          };
          dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
        });

        if (createAssessmentsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: createAssessmentsResponse?.id || "", timeStamp: createAssessmentsResponse?.timestamp || "" }));
          dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: (assessmentsdata?.repairType === "Inhouse" || assessments?.repairType === "Inhouse") ? statusList?.inProgress?.label : statusList?.inProgressOutsource?.label, percentage: processingPercentageValue?.assessmentTab }));
          // setPage("Attachments")
          if (!checkIsFormSubmitButton) {
            setPage("Attachments")
          }
          setOutSourceDialog(true);
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
        } else if (createAssessmentsResponse?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${createAssessmentsResponse?.response?.data?.detail}`)
        }
        else if (createAssessmentsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }
      };

    }
    else if (isValid && (mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 8)) {
      setPage("Attachments")
      dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    } else if (viewmode == true || mappedStatus === 6 || mappedStatus === 7) {
      setPage("Attachments")
      dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
    }
    setLoading(false);


  };


  const handledialogforOutSource = async () => {
    setLoading(true);
    const isValid = handleValidationForRequiredFields();
    if (isValid) {


      const employeeName = await workOrderSummaryRepositry.fetchEmployeeDetails();
      const lovOptions = await workOrderSummaryRepositry.lovOptions();
      const vendorDetails = await workOrderSummaryRepositry.fetchVendorDetails();

      const mapEmpCode = (id) => {
        const empCode = employeeName?.find(empc => empc.id === id);
        return empCode ? empCode.employeecode : '';
      };

      const mapEmpName = (id) => {
        const empCode = employeeName?.find(empN => empN.id === id);
        return empCode ? empCode.employeename : '';
      };

      const mapFlagDesc = (id) => {
        const flagDesc = lovOptions?.femuschworepairflags?.find(desc => desc?.id === id);
        return flagDesc ? flagDesc?.repairflag : '';
      };

      const mapPicDesc = (id) => {
        const picDesc = lovOptions?.femuschworepairpics?.find(desc => desc?.id === id);
        return picDesc ? picDesc?.repairpic : '';
      };

      const mapActivityDesc = (id) => {
        const activityDesc = lovOptions?.femuschworepairactivities?.find(desc => desc?.id === id);
        return activityDesc ? activityDesc?.repairactivity : '';
      };

      const maptoVendorDetails = (id) => {
        const vendor = vendorDetails?.find(v => v?.id === id);
        return vendor ? vendor?.vendorname : '';
      };

      const maptoVendorCode = (id) => {
        const vendor = vendorDetails?.find(v => v?.id === id);
        return vendor ? vendor?.vendorcode : '';
      };

      if (basicDetails?.assessments?.id) {

        const updatePayload = {
          respondedbyid: assessmentsdata?.respondedBy?.id || "",
          responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
          responseenddate: assessmentsdata?.respondedEndDateandTime || "",
          assessmenthrs: "",
          respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
          respondfinding: assessmentsdata?.respondedFinding || "",
          ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
          isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
         [`${serviceType}decontaminationnoticeId`]: assessmentsdata?.decontaminationNotice?.label === "Passed" ? 1 : assessmentsdata?.decontaminationNotice?.label === "Not Passed" ? 2 : "",
          vendorid: assessmentsdata?.vendor?.id || "",
          Respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
          [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
          id: assessments?.id || "",
          timestamp: assessmentsdata?.timeStamp || "",
          isrespond: basicDetails?.isresponse === "Yes" ? 1 : "",
          token: token
        };


        let updateRepairDetailsPayload = [];

        // Common mapping function for existing rows
        const firstNullVendorIndex = rows?.findIndex(r => !r?.vendorId?.id);

        const mappedRowsPayload = rows?.map((row, index) => {
          let repairstartdateValue = row?.startDateandTime || assessmentsdata?.respondedEndDateandTime || "";
          let employeeIdValue = row?.employeename?.id || "";
          let vendorIdValue = row?.vendorId?.id || "";

          // ✅ Special override ONLY for first Inhouse row with vendorid null
          if (
            assessmentsdata?.repairType === "Inhouse" &&
            index === firstNullVendorIndex &&   // only first null-vendor row
            (!row?.endDateandTime || row?.endDateandTime.trim() === "")
          ) {
            repairstartdateValue = assessmentsdata?.respondedEndDateandTime || "";
            employeeIdValue = assessmentsdata?.respondedBy?.id || ""; // if needed
          }

          return {
            employeeid: employeeIdValue,
            repairstartdate: repairstartdateValue,
            repairenddate: row?.endDateandTime || "",
            repairduration: row?.repairDuration || "",
            preparationhours: row?.preparationHours || "",
            verificationhours: row?.verificationHours || "",
            remarks: row?.remarks || "",
            vendorid: vendorIdValue,
            Vendortechnician: row?.technician || "",
            [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
            [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
            id: row?.id || "",
            timestamp: row?.timeStamp || ""
          };
        });
        // Outsource default payload
        const defaultOutsourcePayload = {
          employeeid: "",
          repairstartdate: "",
          repairenddate: "",
          repairduration: "",
          preparationhours: "",
          verificationhours: "",
          remarks: "",
          vendorid: assessmentsdata?.vendor?.id || "",
          Vendortechnician: "",
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
          [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
          id: "",
          timestamp: ""
        };

        // Inhouse default payload (✅ vendorid now matches requirement)
        const defaultInhousePayload = {
          employeeid: assessmentsdata?.respondedBy?.id || "",
          repairstartdate: assessmentsdata?.respondedEndDateandTime || "",
          repairenddate: "",
          repairduration: "",
          preparationhours: "",
          verificationhours: "",
          remarks: "",
          Vendortechnician: "",
          vendorid: "", // ✅ fixed here too
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
          [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
          [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
          id: "",
          timestamp: ""
        };

        // Logic for combining payloads

        const isMappedStatusSpecial = [4, 5, 8, 9].includes(mappedStatus);
        if (isMappedStatusSpecial) {
          updateRepairDetailsPayload = mappedRowsPayload;
        }
        else if (assessmentsdata?.repairType === "Inhouse" && inHouseRows?.length <= 0) {
          updateRepairDetailsPayload = [defaultInhousePayload, ...mappedRowsPayload];
        } else if (assessmentsdata?.repairType === "Outsource" && outsourceRows?.length <= 0) {
          updateRepairDetailsPayload = [defaultOutsourcePayload, ...mappedRowsPayload];
        }
        else {
          updateRepairDetailsPayload = mappedRowsPayload;
        }



        // const updateRepairDetailsPayload = rows?.map((row) => ({
        //   employeeid: row?.employeename?.id || "",
        //   repairstartdate: row?.startDateandTime || "",
        //   repairenddate: row?.endDateandTime || "",
        //   repairduration: row?.repairDuration || "",
        //   preparationhours: row?.preparationHours || "",
        //   verificationhours: row?.verificationHours || "",
        //   remarks: row?.remarks || "",
        //   vendorid: row?.vendorId?.id || "",
        //   Vendortechnician: row?.technician || "",
        //   [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
        //   [`${serviceType}${categoryFieldName}woassessmentheaderId`]: assessments?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
        //   [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
        //   id: row?.id || "",
        //   timestamp: row?.timeStamp || ""
        // }));

        const assesmentsId = basicDetails?.assessments?.id || "";
        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []));

        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                workOrderSummaryRepositry.deleteRepairTracker(
                  serviceType,
                  categoryType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }

        const updateAssessmentDetailsResponse = await workOrderSummaryRepositry.updateAssessmentsDetails(serviceType, updatePayload, categoryType);

        if (updateRepairDetailsPayload?.length > 0) {
          const updateRepairTracker = await workOrderSummaryRepositry.updateRepairTracker(serviceType, updateRepairDetailsPayload, categoryType, assesmentsId);

          updateRepairTracker?.forEach((row) => {
            const transformedObject = {
              employeename: {
                employeeCode: mapEmpCode(row?.employeeid || ""),
                employeename: mapEmpName(row?.employeeid || ""),
                id: row?.employeeid || "",
              },
              flag: {
                id: row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "",
                label: mapFlagDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "")
              },
              pic: {
                id: row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "",
                label: mapPicDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "")
              },
              activity: {
                id: row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "",
                label: mapActivityDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "")
              },
              vendorId: {
                id: row?.vendorid || "",
                label: maptoVendorDetails(row?.vendorid || ""),
                vendorName: maptoVendorDetails(row?.vendorid || ""),
                vendorCode: maptoVendorCode(row?.vendorid || "")
              },
              technician: row?.vendortechnician || "",
              startDateandTime: row?.repairstartdate || "",
              endDateandTime: row?.repairenddate || "",
              repairDuration: row?.repairduration || "",
              preparationHours: row?.preparationhours || "",
              verificationHours: row?.verificationhours || "",
              remarks: row?.remarks || "",
              id: row?.id || "",
              timeStamp: row?.timestamp || ""
            };
            dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
          });
        }

        const service = assetCategoryType?.assetType === "fem" ? "FEMS" : "BEMS";
        const graphUrl = `${window.location.hostname}:${window.location.port}`;
        const emailPayload = {
          vendorId: assessmentsdata?.vendor?.id || "",
          workorderId: basicDetails?.id || "",
          applicationSecurityKey: "ENC45TY-09",
          url: graphUrl,
          serviceId: "",
          service: service,
          token: token,
          category: categoryType,
          statusId: mappedStatus || statusList?.inProgressOutsource?.id,
          Workordertype: basicDetails?.type?.label || "",
          companyId: companyId || "",
          vendorName: assessmentsdata?.vendor?.label || "",
          workorderno: basicDetails?.workOrderNo || "",
          hopitalname: localStorage.getItem("Facilitycodedata") || "",
        };
        await workOrderSummaryRepositry.sendVendorEmail(serviceType, emailPayload);

        const checkStatus = processingPercentage > 70 ? status : (assessmentsdata?.repairType === "Inhouse") ? statusList?.inProgress?.label : statusList?.inProgressOutsource?.label;

        if (updateAssessmentDetailsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: updateAssessmentDetailsResponse?.id || "", timeStamp: updateAssessmentDetailsResponse?.timestamp || "" }));
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
          dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: checkStatus, percentage: processingPercentage }));
        }
        else if (updateAssessmentDetailsResponse?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${updateAssessmentDetailsResponse?.response?.data?.detail}`)
        }
        else if (updateAssessmentDetailsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }
      }

      else {
        const APIPayload = {
          respondedbyid: assessmentsdata?.respondedBy?.id || "",
          responsestartdate: assessmentsdata?.respondedStartDateandTime || "",
          responseenddate: assessmentsdata?.respondedEndDateandTime || "",
          assessmenthrs: "",
          respondedByName: assessmentsdata?.respondedBy?.employeecode || "",
          respondfinding: assessmentsdata?.respondedFinding || "",
          ispartsrequired: assessmentsdata?.partsRequired?.label === "Yes" ? true : assessmentsdata?.partsRequired?.label === "No" ? false : "",
          isassettakenoutlocation: assessmentsdata?.assetTakenLocation?.label === "Yes" ? true : assessmentsdata?.assetTakenLocation?.label === "No" ? false : "",
         [`${serviceType}decontaminationnoticeId`]: assessmentsdata?.decontaminationNotice?.label === "Passed" ? 1 : assessmentsdata?.decontaminationNotice?.label === "Not Passed" ? 2 : "",
          vendorid: assessmentsdata?.vendor?.id || "",
          Respondremarks: assessmentsdata?.outsourceRespondRemarks || "",
          [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
          [`${serviceType}taskdetailsId`]: assessmentsdata?.taskCode?.id || "",
          [`${serviceType}worespondtypeId`]: assessmentsdata?.repairType === "Inhouse" ? 2 : 1 || "",
          token: token
        };

        const createAssessmentsResponse = await workOrderSummaryRepositry.addAssessmentsDetails(serviceType, APIPayload, categoryType);

        const repairDetailsPayload = (categoryType === "Unscheduled" && !isTechnicianRole && rows.length <= 0) ?
          [
            {
              employeeid: assessmentsdata?.repairTracker === "Inhouse" ? assessmentsdata?.respondedBy?.id || "" : "",
              repairstartdate: assessmentsdata?.repairTracker === "Inhouse" ? assessmentsdata?.respondedEndDateandTime || "" : "",
              repairenddate: "",
              repairduration: "",
              preparationhours: "",
              verificationhours: "",
              remarks: "",
              vendorid: assessmentsdata?.repairType === "Inhouse" ? "" : assessmentsdata?.vendor?.id || "",
              Vendortechnician: "",
              [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
              [`${serviceType}${categoryFieldName}woassessmentheaderId`]: createAssessmentsResponse?.id || "",
              [`${serviceType}${repairCategoryFieldName}worepairflagId`]: "",
              [`${serviceType}${repairCategoryFieldName}worepairpicId`]: "",
              [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: "",
              id: "",
              timestamp: ""
            }
          ]
          : rows?.map((row) => ({
            employeeid: row?.employeename?.id || "",
            repairstartdate: categoryType === "Unscheduled" ? (assessmentsdata?.respondedEndDateandTime || rows?.startDateandTime || "") : (row?.startDateandTime || ""),
            repairenddate: row?.endDateandTime || "",
            repairduration: row?.repairDuration || "",
            preparationhours: row?.preparationHours || "",
            verificationhours: row?.verificationHours || "",
            remarks: row?.remarks || "",
            Vendortechnician: row?.technician || "",
            vendorid: row?.vendorId?.id || "",
            [`${serviceType}${categoryFieldName}workorderheaderId`]: basicDetails?.id || "",
            [`${serviceType}${categoryFieldName}woassessmentheaderId`]: createAssessmentsResponse?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairflagId`]: row?.flag?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairpicId`]: row?.pic?.id || "",
            [`${serviceType}${repairCategoryFieldName}worepairactivityId`]: row?.activity?.id || "",
            id: row?.id || "",
            timestamp: row?.timeStamp || ""
          }));

        dispatch(clearRepairtracker("CLEAR_REPAIRTRACKER", []))

        if (deleteRows?.length > 0) {
          try {
            await Promise.all(
              deleteRows.map((row) =>
                workOrderSummaryRepositry.deleteRepairTracker(
                  serviceType,
                  categoryType,
                  row?.id
                )
              )
            );
          } catch (error) {
            console.error("Error during bulk delete:", error);
          }
        }

        const saveRepairTracker = await workOrderSummaryRepositry.addRepairTracker(serviceType, repairDetailsPayload, categoryType);
        const rtLength = saveRepairTracker?.length;
        const getRepairTrackerId = saveRepairTracker?.[rtLength - 1];

        saveRepairTracker?.forEach((row) => {
          const transformedObject = {
            employeename: {
              employeeCode: mapEmpCode(row?.employeeid || ""),
              employeename: mapEmpName(row?.employeeid || ""),
              id: row?.employeeid || "",
            },
            flag: {
              id: row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "",
              label: mapFlagDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairflagId`] || "")
            },
            pic: {
              id: row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "",
              label: mapPicDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairpicId`] || "")
            },
            activity: {
              id: row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "",
              label: mapActivityDesc(row?.[`${serviceType}${repairCategoryFieldName}worepairactivityId`] || "")
            },
            vendorId: {
              id: row?.vendorid || "",
              label: maptoVendorDetails(row?.vendorid || ""),
              vendorName: maptoVendorDetails(row?.vendorid || ""),
              vendorCode: maptoVendorCode(row?.vendorid || "")
            },
            technician: row?.vendortechnician || "",
            startDateandTime: row?.repairstartdate || "",
            endDateandTime: row?.repairenddate || "",
            repairDuration: row?.repairduration || "",
            preparationHours: row?.preparationhours || "",
            verificationHours: row?.verificationhours || "",
            remarks: row?.remarks || "",
            id: row?.id || "",
            timeStamp: row?.timestamp || ""
          };
          dispatch(addRepairTrackerDetails("ADD_REPAIR_TRACKER_DETAILS", transformedObject));
        });
        const service = assetCategoryType?.assetType === "fem" ? "FEMS" : "BEMS";
        const graphUrl = `${window.location.hostname}:${window.location.port}`;
        const emailPayload = {
          vendorId: assessmentsdata?.vendor?.id || "",
          workorderId: basicDetails?.id || "",
          applicationSecurityKey: "ENC45TY-09",
          url: graphUrl,
          serviceId: "",
          service: service,
          token: token,
          category: categoryType,
          statusId: statusList?.inProgressOutsource?.id,
          Workordertype: scheduled ? basicDetails?.type?.label : "",
          companyId: companyId || "",
          vendorName: assessmentsdata?.vendor?.label || "",
          workorderno: basicDetails?.workOrderNo || "",
          hopitalname: localStorage.getItem("Facilitycodedata") || "",
        };
        await workOrderSummaryRepositry.sendVendorEmail(serviceType, emailPayload);

        if (createAssessmentsResponse?.id) {
          dispatch(assessmentsDetails("CREATE_ASSESMENTS", { ...assessmentsdata, id: createAssessmentsResponse?.id || "", repairtrackerId: getRepairTrackerId?.id || "", timeStamp: createAssessmentsResponse?.timestamp || "" }));
          dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: statusList?.inProgressOutsource?.label, percentage: processingPercentageValue?.assessmentTab }))
          dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED")); // Access the checked state of the switch using event.target.checked and set false switch action  
        }
        else if (createAssessmentsResponse?.response?.data?.status === 400) {
          setErrorDialog(true);
          setErrorDialogMssg(`${createAssessmentsResponse?.response?.data?.detail}`)
        }
        else if (createAssessmentsResponse?.response?.data?.status >= 405) {
          setErrorDialog(true);
          setErrorDialogMssg("An unexpected error occurred while processing your request.")
        }

      };

    }
    setLoading(false);
    if (isValid) {
      setOutSourceDialog(true);
    }

  };

  const [inhousenavigate, setInhouseNavigate] = useState(false);

  const handleSubmitButton = (e) => {
    if (setOutsourceDetails) {
      handledialogforOutSource();
    } else {
      setInhouseNavigate(true);
      handleSubmitContinueButton(e, isFormSubmitButton);

    }
  };


  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await fetchOptions();
      setLoading(false);
    };
    fetchData();

    if (assessments?.id) {
      return;
    } else {

      const getAutoAssign = async () => {
        setLoading(true);
        await getEmpNameForAutoAssign();
      }

      setAssessmentsData((prev) => ({
        ...prev,
        respondedStartDateandTime: empFieldDisable ? prev?.respondedStartDateandTime : basicDetails?.workorderDateandTime,
        respondedEndDateandTime: prev?.respondedEndDateandTime || "",
      }));
      setLoading(false);
      getAutoAssign();

    }

    if (!scheduled && !assessments?.id) {
      setAssessmentsData((prev) => ({
        ...prev,
        repairType: basicDetails?.assetNo?.repairType || "",
      }));
    }

  }, []);



  useMemo(() => {
    if (roleName !== "technician" || categoryType !== "Unscheduled") return;


    if (assessments?.id) {
      setDisableRespondBy(true);
      return;
    }

    const getTechnicianId = option?.respondedBy?.find(
      item => String(item.userId).toLowerCase() === String(userId).toLowerCase()
    );

    setAssessmentsData(prev => ({
      ...prev,
      respondedBy: {
        id: getTechnicianId?.id || "",
        label: getTechnicianId?.employeename || "",
        designation: getTechnicianId?.designation || "",
        empservice: getTechnicianId?.empservice || "",
        employeecode: getTechnicianId?.employeecode || "",
      },
      designation: getTechnicianId?.designation || "",
    }));

    const checkIsDisable =
      roleName === "technician" && !(isWeekend || isOutsideDayShift);


    setDisableRespondBy(checkIsDisable);
  }, [option?.respondedBy]);


  const handleConfirm = () => {
    handleCloseDialog();
  };

  const handleOpenDialog = () => {
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setEditData(null);
  };

  const handleEdit = (row) => {
    setEditData({ ...row });
    setDialogOpen(true);
  };

  const handleCloseErrRequestDialog = () => {
    setErrorDialog(false);
    setErrorDialogMssg("");
  };

  const handleConfirmErrRequestDialog = (e) => {
    e.preventDefault();
    setErrorDialog(false);
    setErrorDialogMssg("")
  };


  const handleOpenModal = () => setIsModalOpen(true);
  const handleCloseModal = () => setIsModalOpen(false);

  const handleTaskCodeClick = (rowData) => {
    setAssessmentsData((prev) => ({
      ...prev,
      taskCode: { ...rowData, label: rowData?.taskCode ? rowData?.taskCode : '' },
      taskDescription: rowData?.taskDesc || ""
    }));

    setError((prev) => ({
      ...prev,
      taskCode: false

    }));

    setErrorMessage((prev) => ({
      ...prev,
      taskCode: ''
    }));

    // Close the modal after asset selection
    handleCloseModal();
  };

  const columns = [
    {
      headerName: 'Task Code',
      field: 'taskCode',
      width: 150,
      cellRenderer: (params) => (
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            handleTaskCodeClick(params.data);
          }}
          style={{
            color: 'blue',
            textDecoration: 'underline',
            cursor: 'pointer',
          }}
        >
          {params.value}
        </a>
      ),
    },
    { headerName: 'Task Description', field: 'taskDesc', width: 200 },
    { headerName: 'Service', field: 'serviceName', width: 100 },
    { headerName: 'Work Group Code', field: 'wgCode', width: 150 },
    { headerName: 'Work Group Description', field: 'wgDesc', width: 150 }

  ];



  return (
    <>
      <PageLoader open={loading} />
      <ComponentHeader
        mainHeader={findHeaderContent?.mainHeader}
        subHeader={findHeaderContent?.subHeader}
        secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
        requiredButton={viewmode ? false : findHeaderContent?.requiredButton}
      />
      <Box >
        <form style={{ position: "relative" }} onSubmit={handleSubmitContinueButton} noValidate>
          <Stack direction={'row'} alignItems={'center'} gap={1.5}>
            <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.workOrderNo || ""}</Typography>
          </Stack>
          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            {!scheduled && <Typography variant='title2'> Responded Details </Typography>}
            <Grid container spacing={2}>
              {/* { (!setOutsourceDetails || !(assessmentsdata?.repairType === "Outsource")) && (
                <> */}
              <Grid item xs={12} md={4} sm={6}>
                <CustomTextFieldWithSearch
                  label={scheduled ? "Assignee" : "Responded By"}
                  id="respondedDetails"
                  name="respondedBy"
                  onChange={handleOnchange}
                  options={option?.respondedBy || []}
                  value={assessmentsdata?.respondedBy || ""}
                  error={error?.respondedBy}
                  errorMessage={errorMessage?.respondedBy}
                  isMandatoryField={!(scheduled && setOutsourceDetails) ? true : false}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || disableRespondBy}
                  // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || assessments?.id || empFieldDisable}
                  autoFocus
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Designation"
                  id="designation"
                  name="designation"
                  onChange={handleOnchange}
                  value={assessmentsdata?.designation || ""}
                  disabled={true}
                />
              </Grid>
              {/* </>
                )} */}
              {!scheduled && (
                <>
                  <Grid item xs={6} md={4} sm={6}>
                    <CustomTextField
                      label="Transfer To"
                      id="transferTo"
                      value={basicDetails?.transferto || ""}
                      disabled={true}

                    />
                  </Grid>
                  <Grid item xs={6} md={4} sm={6}>
                    <CustomDateTimePicker
                      label="Responded Start Date and Time"
                      onDateChange={(e) => handleOnchange(e, "respondedStartDateandTime")}
                      value={assessmentsdata?.respondedStartDateandTime}
                      error={error?.respondedStartDateandTime}
                      helperText={errorMessage?.respondedStartDateandTime}
                      disableFutureDate={false}
                      isMandatoryField={true}
                      displayDefaultValue={false}
                      disabled={true}
                    // disabled={viewmode || mappedStatus === 6 || mappedStatus ===7 || empFieldDisable}
                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || empFieldDisable}
                    />
                  </Grid>
                  <Grid item xs={6} md={4} sm={6}>
                    <CustomDateTimePicker
                      label="Responded End Date and Time"
                      value={assessmentsdata?.respondedEndDateandTime || ""}
                      onDateChange={(e) => handleOnchange(e, "respondedEndDateandTime")}
                      error={error?.respondedEndDateandTime}
                      helperText={errorMessage?.respondedEndDateandTime}
                      disableFutureDate={false}
                      freezeDate={(localStorage.getItem("roleName") !== "Helpdesk" && localStorage.getItem("roleName") !== "FMSExec" && basicDetails?.assessments?.id && basicDetails?.assessments?.respondedEndDateandTime) ? true : false}
                      allowManualInput={localStorage.getItem("roleName") !== "Helpdesk" && localStorage.getItem("roleName") !== "FMSExec" ? false : true}
                      isMandatoryField={categoryType === "Unscheduled" ? isMandatoryField : false}
                      displayDefaultValue={false}
                      disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                    />
                  </Grid>
                </>
              )}
              <Grid item xs={(viewmode) ? 12 : 11.5} md={(viewmode) ? 4 : 3.5} sm={(viewmode) ? 6 : 5.5} >
                {/* <Grid item xs={(viewmode || setScheduledField) ? 12 : 11.5} md={(viewmode || setScheduledField) ? 4 : 3.5} sm={(viewmode || setScheduledField) ? 6 : 5.5} > */}
                <CustomTextFieldWithSearch
                  label={"Task Code"}
                  id={"taskCode"}
                  name={"taskCode"}
                  onChange={handleOnchange}
                  value={assessmentsdata?.taskCode || ""}
                  options={option?.taskCode || []}
                  error={error?.taskCode}
                  errorMessage={errorMessage?.taskCode}
                  isMandatoryField={categoryType === "Unscheduled" ? isMandatoryField : categoryType === "Scheduled" ? true : false}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || scheduled}
                  // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || scheduled}
                  hideSearch={true}
                />
              </Grid>

              {(!viewmode && !setScheduledField) && (<Grid item xs={0.5} md={0.5} sm={0.5} >

                {!viewmode && (
                  <Grid sx={{ mt: 2.7 }} item>
                    <Button
                      onClick={handleOpenModal}
                      variant="contained"
                      sx={{ minWidth: '32px', minHeight: '32px', marginLeft: '0rem' }}
                      disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || scheduled}>
                      {/* disabled={ viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}> */}
                      <SearchIcon fontSize="small" />
                    </Button>
                  </Grid>
                )}

                <Dialog
                  open={isModalOpen}
                  onClose={(event, reason) => {
                    if (reason === "backdropClick") {
                      return; // Prevent closing on backdrop click
                    }
                    handleCloseModal(); // Call the close function for other reasons
                  }}
                  aria-labelledby="asset-grid-dialog"
                  aria-describedby="grid-display-for-assets"
                  maxWidth="lg"
                  fullWidth
                ><DialogTitle
                  id="asset-grid-dialog"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1.5rem', // Adjust font size as desired
                    display: 'flex',
                    justifyContent: 'space-between', // Space out title and icon
                    alignItems: 'center',
                  }}
                >
                    Task Code Search
                    <IconButton
                      aria-label="close"
                      variant="outlined"
                      onClick={handleCloseModal}
                      sx={{
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </DialogTitle>
                  <DialogContent
                    dividers
                    sx={{
                      overflowY: 'auto', // Enables scroll if content overflows
                      height: 'auto',    // Allows height to adjust based on content
                      maxHeight: 'auto', // Sets a maximum height to prevent it from growing too large
                    }}
                  >
                    <CustomAgGrid
                      rows={option?.taskCode || []}
                      columns={columns}
                      // loading={loadingAssets}
                      refSet={gridAPI}
                      setGridApi={setGridApi}
                    />
                    <Stack my={3} direction={"row"} justifyContent={"end"}>
                      <Button variant="outlined" onClick={handleCloseModal}>
                        Close
                      </Button>
                    </Stack>
                  </DialogContent>
                </Dialog>

              </Grid>)}

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextField
                  label="Task Description"
                  id="taskdescription"
                  name="taskDescription"
                  onChange={handleOnchange}
                  value={assessmentsdata?.taskDescription || ""}
                  disabled={true}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <FormControl component="fieldset" error={error.repairType}>
                  <Typography variant="labelSm" color={"text.primary"} component={"label"}>
                    Repair Type
                    <Typography component={"span"} color={"error"}>
                      *
                    </Typography>
                  </Typography>
                  <RadioGroup
                    row
                    name="repairType"
                    onChange={handleRepairTypeChange}
                    value={(mappedStatus === 1 || mappedStatus === 3 || mappedStatus === 10) ? (assessmentsdata?.repairType || "") : (assessmentsdata?.repairType || basicDetails?.assessments?.repairType || "")}
                    aria-required={true}
                    defaultValue="Inhouse"
                  >
                    <FormControlLabel value="Inhouse" control={<Radio />} label="Inhouse" disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || scheduled} />
                    {/* <FormControlLabel value="Inhouse" control={<Radio />} label="Inhouse" disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || scheduled} /> */}
                    <FormControlLabel value="Outsource" control={<Radio />} label="Outsource" disabled={viewmode || mappedStatus === 6 || mappedStatus === 7 || scheduled} />
                    {/* <FormControlLabel value="Outsource" control={<Radio />} label="Outsource" disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8 || scheduled} /> */}
                  </RadioGroup>
                  <FormHelperText>{errorMessage.repairType}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  label={"Parts Required"}
                  name="partsRequired"
                  value={assessmentsdata?.partsRequired || ""}
                  onChange={handleOnchange}
                  options={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}

                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  label={"Asset Taken Location"}
                  name="assetTakenLocation"
                  value={assessmentsdata?.assetTakenLocation || ""}
                  onChange={handleOnchange}
                  options={[{ id: 1, label: "Yes" }, { id: 2, label: "No" }]}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                />
              </Grid>
              <Grid item xs={12} md={4} sm={6}>
                <CustomSelectInput
                  label={"Decontamination Notice"}
                  name="decontaminationNotice"
                  value={assessmentsdata?.decontaminationNotice || ""}
                  disableClearable={true}
                  onChange={handleOnchange}
                  options={[{ id: 1, label: "Passed" }, { id: 2, label: "Not Passed" }]}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}


                />
              </Grid>

              <Grid item xs={12} md={4} sm={6}>
                <CustomTextArea
                  label={scheduled ? "Assignee Finding" : "Respond Finding"}
                  id="respondedFinding"
                  onChange={(e) => handleOnchange(e, "respondedFinding")}
                  value={assessmentsdata?.respondedFinding || ""}
                  disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                  isMandatoryField={categoryType === "Unscheduled" ? isMandatoryField : false}
                  error={error?.respondedFinding}
                  helperText={errorMessage?.respondedFinding || ""}
                  // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                  maxLength={100}
                />
              </Grid>
            </Grid>
          </Box>

          {(setOutsourceDetails) && (
            <>
              <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                <Typography variant='title2' >Outsource Details</Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={4} sm={6}>
                    <CustomTextFieldWithSearch
                      label={"Vendor"}
                      id={"vendor"}
                      name={"vendor"}
                      onChange={handleOnchange}
                      value={assessmentsdata?.vendor || ""}
                      options={option?.vendor || []}
                      disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                      isMandatoryField={setOutsourceDetails ? true : false}
                      error={error?.vendor}
                      errorMessage={errorMessage?.vendor || ""}
                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                    />
                  </Grid>
                  <Grid item xs={12} md={4} sm={6}>
                    <CustomTextField
                      label="Outsource Respond remarks"
                      name="outsourceRespondRemarks"
                      value={assessmentsdata?.outsourceRespondRemarks || ""}
                      onChange={handleOnchange}
                      disabled={viewmode || mappedStatus === 6 || mappedStatus === 7}
                    // disabled={viewmode || mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 || mappedStatus === 8}
                    />
                  </Grid>
                </Grid>
              </Box>
            </>
          )}

          <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
            <Stack direction="row" spacing={1.5} alignItems="center" justifyContent="space-between" mb={2}>
              <Typography variant='title2'> Repair Tracker </Typography>
              <Box sx={{ flexGrow: 1 }} />
              {/* {!viewmode && mappedStatus !== 6 && mappedStatus !== 7 && mappedStatus !== 5 && ( */}
              {!viewmode && mappedStatus !== 6 && mappedStatus !== 7 && mappedStatus !== 5 && mappedStatus !== 4 && mappedStatus !== 9 && mappedStatus !== 8 && (
                <AddRowButton onClick={handleOpenDialog} isDisabled={checkBtnDisable || ((assessmentsdata?.repairType === "Outsource") ? !assessmentsdata?.vendor?.id : false)} />
              )}
            </Stack>
            {error?.repairTrackerRows && (
              <Typography component={"span"} color={"error"}>
                {errorMessage?.repairTrackerRows}*
              </Typography>
            )}
            <CustomAgGrid
              refSet={gridAPI}
              rows={assessmentsdata?.repairType === "Outsource" ? outsourceRows : inHouseRows || []}
              columns={columns_Field}
              setGridApi={setGridApi}
              handleDelete={shouldEnableDeleteAndEdit ? (row) => handleDelete(row) : null}
              handleEdit={shouldEnableDeleteAndEdit ? (row) => handleEdit(row) : null}
              isEditBtnDisabled={checkBtnDisable}
              isDeleteBtnDisabled={checkBtnDisable}
            />

          </Box>

          <Box>
            <BottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} outsourseSubmitBtn={true} enableAuthorizeButton={false} outsourceHandleConfirm={() => handleSubmitButton({ preventDefault: () => { } })} disableSubmitBtn={mappedStatus === 4 || mappedStatus === 5 || mappedStatus === 6 ? true : false} />
          </Box>
        </form>
      </Box>

      <AddRowDialogue
        open={dialogOpen}
        onClose={handleCloseDialog}
        onConfirm={handleConfirm}
        editMode={editData}
        rows={rows}
        setRows={setRows}
        vendorId={assessmentsdata?.vendor || ""}
        RepairType={assessmentsdata?.repairType === "Inhouse" ? true : false}
        RespondedEndDateandTime={assessmentsdata?.respondedEndDateandTime || ""}
      />
      <CustomAlert
        open={outSourceDialog}
        onClose={handleCloseDialog}
        onConfirm={handleOutsourceSubmit}
        content={
          assessmentsdata?.repairType === "Inhouse"
            ? `${basicDetails?.workOrderNo || ""} has been successfully shared to Technician`
            : `${basicDetails?.workOrderNo || ""} has been successfully shared to Vendor`
        }
        confirmBtn='OK'
      />

      <CustomAlert
        open={errorDialog}
        onClose={handleCloseErrRequestDialog}
        onConfirm={handleConfirmErrRequestDialog}
        content={errorDialogMssg}
        confirmBtn='OK'
      />

      <CustomDialog
        open={deleteDialog}
        onClose={handleCloseCancelDialog}
        onConfirm={handleConfirmDelete}
        content="Are you sure you want to Delete?"
        cancelBtn="No"
        confirmBtn="Yes"
      />

    </>
  );
};

export default Assessments
